// QUCK ADD BUTTON FOR PRODUCT WITH MORE OPTIONS
const allQSButtons = document.querySelectorAll("button[data-quickshop]");

async function fetchQuickShopComponentByHandle(handle) {
	return fetch(`/products/${handle}?view=quickshop`).then(res => res.text());
}

async function fetchProductJSON(handle) {
	return fetch(`/products/${handle}.json`).then(res => res.json());
}

function clearShopModal() {
	document.getElementById("theme-quickshop-modal").innerHTML = "";
}

async function quickShopBtnClickHandler(event) {
	const {
		dataset: { quickshop },
	} = event.target;

	const quickshopComponent = await fetchQuickShopComponentByHandle(quickshop);

	document.getElementById("theme-quickshop-modal").innerHTML =
		quickshopComponent;

	const modalForm = document.querySelector("#theme-quickshop-modal form");
	if (modalForm) ProductForm(modalForm);

	document
		.querySelector("#theme-quickshop-modal .close-btn")
		.addEventListener("click", clearShopModal);

	const addToCartBtn = document.querySelector(
		'#theme-quickshop-modal button[type="submit"'
	);

	// Adding stamped reviews async
	StampedFn.reloadUGC();

	addToCartBtn.addEventListener("click", async event => {
		try {
			event.preventDefault();
			const form = event.target.closest("form");
			if (!form) return;

			const formId = form.querySelector("#variant-id").value;
			const formData = {
				items: [{ id: formId }],
			};

			if (addToCartBtn.classList.contains("button-orange-alt")) return;

			const response = await fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(formData),
			});

			if (!response.ok) {
				throw new Error(
					`Failed to add item to cart. Status: ${response.status}`
				);
			}

			// console.log("Item added to cart successfully:", response);
		} catch (error) {
			console.error("Error:", error);
		}
	});
}

Array.from(allQSButtons).forEach($btn =>
	$btn.addEventListener("click", quickShopBtnClickHandler)
);
